const state = {
  presentationMode:
    localStorage.getItem("presentationMode") === "true" || false,
  sensitiveTexts: []
};

const mutations = {
  TOGGLE_PRESENTATION_MODE(state) {
    state.presentationMode = !state.presentationMode;
    localStorage.setItem("presentationMode", state.presentationMode);
  },
  SET_PRESENTATION_MODE(state, value) {
    state.presentationMode = value;
    localStorage.setItem("presentationMode", state.presentationMode);
  },
  SET_SENSITIVE_TEXTS(state, texts) {
    state.sensitiveTexts = (texts || []).map((t) => String(t).toLowerCase());
  }
};

const actions = {
  togglePresentationMode({ commit }) {
    commit("TOGGLE_PRESENTATION_MODE");
  },
  setPresentationMode({ commit }, value) {
    commit("SET_PRESENTATION_MODE", value);
  },
  setSensitiveTexts({ commit }, texts) {
    commit("SET_SENSITIVE_TEXTS", texts);
  },
  applyGlobalBlur() {
    return;
  }
};

const getters = {
  isPresentationMode: (state) => state.presentationMode,
  sensitiveTexts: (state) => state.sensitiveTexts
};

export default {
  state,
  mutations,
  actions,
  getters
};
